import type { SellerRepository } from '../repository/seller.repository';

/**
 * Application API for seller storefront documents and related user subcollections.
 */
export class SellerService {
  constructor(private readonly sellers: SellerRepository) {}

  getSellerProfile(userId: string) {
    return this.sellers.getSellerProfile(userId);
  }

  /** Replace seller document (e.g. wizard completion). */
  setSellerProfile(userId: string, data: Record<string, unknown>) {
    return this.sellers.setSellerProfile(userId, data);
  }

  mergeSellerProfile(userId: string, data: Record<string, unknown>) {
    return this.sellers.mergeSellerProfile(userId, data);
  }

  updateSellerProfile(userId: string, patch: Record<string, unknown>) {
    return this.sellers.updateSellerProfile(userId, patch);
  }

  initializeSellerStats(userId: string) {
    return this.sellers.initializeSellerStats(userId);
  }
}
